import {
    ADD_AVAILABILITY_FAILURE,
    ADD_AVAILABILITY_REQUEST,
    ADD_AVAILABILITY_SUCCESS,
    GET_AVAILABILITIES_FAILURE,
    GET_AVAILABILITIES_LOGS_FAILURE,
    GET_AVAILABILITIES_LOGS_REQUEST,
    GET_AVAILABILITIES_LOGS_RESET,
    GET_AVAILABILITIES_LOGS_SUCCESS,
    GET_AVAILABILITIES_REQUEST,
    GET_AVAILABILITIES_SUCCESS,
    GET_CONFLICTED_AVAILABILITY_FAILURE,
    GET_CONFLICTED_AVAILABILITY_REQUEST,
    GET_CONFLICTED_AVAILABILITY_SUCCESS,
    REMOVE_CONFLICTED_AVAILABILITY_FAILURE,
    REMOVE_CONFLICTED_AVAILABILITY_REQUEST,
    REMOVE_CONFLICTED_AVAILABILITY_SUCCESS,
    REMOVE_EXISTING_AVAILABILITY_FAILURE,
    REMOVE_EXISTING_AVAILABILITY_REQUEST,
    REMOVE_EXISTING_AVAILABILITY_SUCCESS,
} from '../constants/availability.constant';
import { AnyIfEmpty } from 'react-redux';

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
    conflictedAvailability: {
        loading: false,
        data: [],
        errorMsg: '',
    },
    availabilies: {
        loading: false,
        data: [],
        errorMsg: '',
    },
    availabiliesLogs: {
        loading: false,
        data: [],
        errorMsg: '',
    }
};

export const availabilityReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case ADD_AVAILABILITY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ADD_AVAILABILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case ADD_AVAILABILITY_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };
        case GET_CONFLICTED_AVAILABILITY_REQUEST:
            return {
                ...state,
                conflictedAvailability: {
                    ...state.conflictedAvailability,
                    loading: true,
                },
            };
        case GET_CONFLICTED_AVAILABILITY_SUCCESS:
            return {
                ...state,
                conflictedAvailability: {
                    ...state.conflictedAvailability,
                    loading: false,
                    data: action.payload,
                },
            };
        case GET_CONFLICTED_AVAILABILITY_FAILURE:
            return {
                ...state,
                conflictedAvailability: {
                    ...state.conflictedAvailability,
                    loading: false,
                    errorMsg: action.payload,
                },
            };
        case REMOVE_CONFLICTED_AVAILABILITY_REQUEST:
            return {
                ...state,
                conflictedAvailability: {
                    ...state.conflictedAvailability,
                    loading: true,
                },
            };
        case REMOVE_CONFLICTED_AVAILABILITY_SUCCESS:
            return {
                ...state,
                conflictedAvailability: {
                    ...state.conflictedAvailability,
                    loading: false,
                    data: action.payload,
                },
            };
        case REMOVE_CONFLICTED_AVAILABILITY_FAILURE:
            return {
                ...state,
                conflictedAvailability: {
                    ...state.conflictedAvailability,
                    loading: false,
                    errorMsg: action.payload,
                },
            };
        case GET_AVAILABILITIES_REQUEST:
            return {
                ...state,
                availabilies: {
                    ...state.availabilies,
                    loading: true,
                    // Clear data on new request to prevent showing stale data during tab switches
                    data: [],
                    errorMsg: '',
                },
            };
        case 'GET_AVAILABILITIES_CLEAR':
            return {
                ...state,
                availabilies: {
                    ...state.availabilies,
                    loading: false, // Don't change loading state, just clear data
                    data: [],
                    errorMsg: '',
                },
            };
        case GET_AVAILABILITIES_SUCCESS:
            return {
                ...state,
                availabilies: {
                    ...state.availabilies,
                    loading: false,
                    data: action.payload,
                },
            };
        case GET_AVAILABILITIES_FAILURE:
            return {
                ...state,
                availabilies: {
                    ...state.availabilies,
                    loading: false,
                    errorMsg: action.payload,
                },
            };
        case REMOVE_EXISTING_AVAILABILITY_REQUEST:
            return {
                ...state,
                availabilies: {
                    ...state.availabilies,
                    loading: true,
                },
            };
        case REMOVE_EXISTING_AVAILABILITY_SUCCESS:
            return {
                ...state,
                availabilies: {
                    ...state.availabilies,
                    loading: false,
                    data: action.payload,
                },
            };
        case REMOVE_EXISTING_AVAILABILITY_FAILURE:
            return {
                ...state,
                availabilies: {
                    ...state.availabilies,
                    loading: false,
                    errorMsg: action.payload,
                },
            };
        case GET_AVAILABILITIES_LOGS_REQUEST:
            return {
                ...state,
                availabiliesLogs: {
                    ...state.availabiliesLogs,
                    loading: true,
                }
            };

        case GET_AVAILABILITIES_LOGS_SUCCESS:
            return {
                ...state,
                availabiliesLogs: {
                    ...state.availabiliesLogs,
                    loading: false,
                    data: action.payload,
                }
            }
        case GET_AVAILABILITIES_LOGS_FAILURE:
            return {
                ...state,
                availabiliesLogs: {
                    ...state.availabiliesLogs,
                    loading: false,
                    data: [],
                    errorMsg: action.payload,
                }
            }

        case GET_AVAILABILITIES_LOGS_RESET: {
            return {
                ...state,
                availabiliesLogs: {
                    ...state.availabiliesLogs,
                    loading: false,
                    data: [],
                    errorMsg: ''
                }
            }
        }

        default:
            return state;
    }
};
